module.exports = __webpack_public_path__ + "img/logoCAS2.c51d885f.png";